<template>
  <div class="login">
    <v-card-text primary-title class="pb-0 pt-2 text-xs-center" row>
      <h2 class="headline">Login to Survey</h2>
    </v-card-text>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="data.username"
          data-test="username"
          :rules="[rules.required]"
          type="text"
          label="Your name"
        ></v-text-field>

        <v-text-field
          v-model="data.password"
          ref="password"
          data-test="password"
          :append-icon="visiblePassword ? 'visibility_off' : 'visibility'"
          :rules="[rules.required, rules.min]"
          :type="visiblePassword ? 'text' : 'password'"
          label="Enter your password"
          counter
          :hide-details="$refs.password && $refs.password.isFocused"
          @click:append="visiblePassword = !visiblePassword"
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions class="pb-4">
      <v-btn
        color="error"
        large
        @click="clear"
      >
        Cancel
      </v-btn>

      <v-btn
        data-test="submit"
        :disabled="!valid"
        color="success"
        large
        @click="submit"
      >
        Login to survey
      </v-btn>
    </v-card-actions>

    <div class="caption">
      Your responses to this survey are anonymous.
      <br/>
      No attempt will be made to determine the identity of respondents.
    </div>
  </div>
</template>

<script>
import { values } from 'lodash'
import { email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

import store from '@/store'
import ErrorsModal from '@/components/ErrorsModal'

export default {
  components: {
    ErrorsModal,
  },

  data () {
    return {
      data: {
        username: '',
        password: ''
        /* contact_email: '',
        contact_phone: '' */
      },
      valid: false,
      errors: {
        active: false,
        content: {}
      },
      visiblePassword: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters',
        email: v => email(v) || 'Must be an email address'
      },
    }
  },

  async created () {
    this.loadingModalActive(true)

    const checkUrl = `surveys/${this.$route.params.slug}/check`
    this.$axios.post(checkUrl, {})
      .then((response) => {
        this.loadingModalActive(false)
      })
      .catch((error) => {
        switch(error.response.status) {
          case 403:
            this.errors.active = true
            this.errors.content.error = ['This survey is already closed.']
            this.errors.canClose = false
            break
          case 404:
            this.errors.active = true
            this.errors.content.error = ['The requested survey could not be found.']
            this.errors.canClose = false
            break
          default:
            console.log(error)
            this.errors.active = true
            this.errors.content.error = ['We were unable to open the requested survey.']
            this.errors.canClose = false
            break
        }
      })
      .finally(() => {
        this.loadingModalActive(false)
      })
  },

  methods: {
    ...mapActions({
      loadingModalActive: 'root/loadingModalActive',
    }),

    async submit () {
      if (this.$refs.form.validate()) {
        const slug = this.$route.params.slug

        const success = await store.dispatch('root/login', {
          url: `surveys/${slug}/login`,
          data: this.data,
          survey_slug: slug
        })

        if(success) {
          this.$router.push({ name: 'survey', params: { slug } })
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
  div.login {
    padding: 25px 40px;
  }

  h2.headline {
    font-size: 32px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #545353;
  }

  .caption {
    padding-bottom: 10px;
    text-align: center;
  }
</style>